import React from "react";
import { List, Box, LinearProgress } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import CircularProgressCustom from "../../CircularProgressCustom";


const InfinitScroll = React.memo(({ articles, fetchItems, hasMore, loading, Child }) => {

  console.log(articles)
  return (
    <Box id="scrollableDiv" sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflowAnchor: 'none', overflow: 'auto', width: '100%' }}>
      {/* Si se está cargando, muestra un progreso */}
      {/* {loading && <LinearProgress />} */}
      <Box sx={{ flexGrow: 1, height: '100vh', }}>
        <InfiniteScroll
          dataLength={articles.length} // Número de items actuales
          next={fetchItems} // Función que carga más elementos
          hasMore={hasMore} // Si hay más items para cargar
          loader={<CircularProgressCustom size={350}/>} // Loader que se muestra mientras carga
          endMessage={<p>No hay más artículos</p>} // Mensaje al final
          scrollThreshold={0.9} // Cargar más cuando esté al 90% del scroll
          scrollableTarget="scrollableDiv"
        >
          <List>
            <Child />
          </List>
        </InfiniteScroll>
      </Box>
    </Box>
  );

});

export default InfinitScroll